export default __webpack_public_path__ + "static/media/book.c285e3c2.svg";